module.exports = __webpack_public_path__ + "img/979e93ff47c6a92ae09595bcd184c4c0.c95f4619.jpg";